import React, { Suspense, lazy } from 'react';
import { useDashboard } from '../../contexts/DashboardContext';

// Lazy loading разделов
const UsersSection = lazy(() => import('../sections/UsersSection'));
const SeriesSection = lazy(() => import('../sections/SeriesSection'));
const PulseSection = lazy(() => import('../sections/PulseSection'));
const ShowcaseSection = lazy(() => import('../sections/ShowcaseSection'));

const ContentArea = () => {
  const { activeSection } = useDashboard();

  const renderSection = () => {
    switch (activeSection) {
      case 'users':
        return <UsersSection />;
      case 'series':
        return <SeriesSection />;
      case 'pulse':
        return <PulseSection />;
      case 'showcase':
        return <ShowcaseSection />;
      default:
        return <div>Выберите раздел</div>;
    }
  };

  return (
    <div className="flex-1 overflow-y-auto">
      <Suspense fallback={
        <div className="flex flex-col items-center justify-center min-h-[400px] text-muted-foreground">
          <div className="w-12 h-12 border-4 border-border border-t-primary rounded-full animate-spin mb-4"></div>
          <p className="text-base">Загрузка раздела...</p>
        </div>
      }>
        {renderSection()}
      </Suspense>
    </div>
  );
};

export default ContentArea;
